export function decimalUnits(value: number): bigint {
  if (!Number.isFinite(value) || Math.abs(value) > 1e12) throw new Error("Geçersiz parasal tutar.");
  return BigInt(value.toFixed(8).replace(".", ""));
}

export function roundedCents(scaled: bigint): string {
  const absolute = scaled < 0n ? -scaled : scaled;
  const rounded = (absolute + 500_000n) / 1_000_000n;
  return String(scaled < 0n ? -rounded : rounded);
}

export function decimalCents(value: number): string {
  return roundedCents(decimalUnits(value));
}

export function sumSourceCents(rows: ReadonlyArray<{ debit: number; credit: number }>): string {
  return roundedCents(rows.reduce((sum, row) => sum + decimalUnits(row.debit) - decimalUnits(row.credit), 0n));
}

export function sourceBalanceMatches(total: string, expected: number): boolean {
  const difference = BigInt(total) - BigInt(decimalCents(expected));
  return difference >= -1n && difference <= 1n;
}

export function filterFinanceAccounts(accounts: ReadonlyArray<FinanceAccount>,
  filters: { currency: string; direction: string; search: string }) {
  const term = filters.search.trim().toLocaleLowerCase("tr-TR");
  return accounts.filter((row) => (!filters.currency || row.currency === filters.currency)
    && (filters.direction === "all" || (filters.direction === "receivable" ? BigInt(row.balance) > 0n : BigInt(row.balance) < 0n))
    && (!term || `${row.code} ${row.name}`.toLocaleLowerCase("tr-TR").includes(term)));
}
import type { FinanceAccount } from "./account-finance-contract.js";
